<script setup lang="ts">
import { LoaderCircle } from 'lucide-vue-next'
</script>

<template>
  <div
    class="flex flex-col gap-2 w-full items-center px-2 h-full justify-center overflow-hidden min-h-96"
  >
    <LoaderCircle class="w-20 h-20 text-slate-700 animate-spin" stroke-width="1.5" />
    <div class="text-sm text-slate-500 w-full">
      <p>Vi verifiserer betalingen din. Dette kan ta noen sekunder. Vennligst ikke lukk vinduet.</p>
    </div>
  </div>
</template>
